module.exports = __webpack_public_path__ + "static/media/check.c96f0d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logos/check.png
// module id = 103
// module chunks = 0